import { render } from "./rfcSelector.vue?vue&type=template&id=618ab1d8&scoped=true"
import script from "./rfcSelector.vue?vue&type=script&lang=js"
export * from "./rfcSelector.vue?vue&type=script&lang=js"

import "./rfcSelector.vue?vue&type=style&index=0&id=618ab1d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618ab1d8"]])

export default __exports__